import { TLink } from "../../../../../types";
import LinkWrapper from "../../../../elements/link-wrapper/link-wrapper";
import MobileMenuActionBar from "../mobile-menu-action-bar/mobile-menu-action-bar";
import styles from "./mobile-second-level-menu.module.less";

type TMobileSecondLevelMenuProps = {
  title?: string;
  menuItems?: Array<TLink>;
  onClickClose: () => void;
  onClickBack: () => void;
};

const MobileSecondLevelMenu = ({ title, menuItems, onClickBack, onClickClose }: TMobileSecondLevelMenuProps) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.innerWrapper}>
        <div className={styles.topItemsWrapper}>
          <p className={[styles.title, "eyebrow mb-xs"].join(" ")}>{title}</p>
          <ul className={styles.items}>
            {menuItems?.map((item, index) => {
              return (
                <li key={index} className={styles.item}>
                  <LinkWrapper
                    className={[styles.link, "body-l"].join(" ")}
                    url={item?.url}
                    title={item?.title}
                    onPreNavigate={item?.onPreNavigate}
                  />
                </li>
              );
            })}
          </ul>
        </div>
      </div>
      <MobileMenuActionBar onClickClose={onClickClose} onClickBack={onClickBack} />
    </div>
  );
};

export default MobileSecondLevelMenu;
